module.exports = __webpack_public_path__ + "media/images/menu/icn-profile-f3a43cf88c2dae02071feb51bb86741f.svg";